import { render, staticRenderFns } from "./Landingpage.vue?vue&type=template&id=4cd7e9a4&scoped=true&"
import script from "./Landingpage.vue?vue&type=script&lang=js&"
export * from "./Landingpage.vue?vue&type=script&lang=js&"
import style0 from "./Landingpage.vue?vue&type=style&index=0&id=4cd7e9a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd7e9a4",
  null
  
)

export default component.exports